import React, { useRef, useState, useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import { Box, Typography, Divider, Button } from "@mui/material";
import foglar from "../../assets/foglar.webp";
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
import DocuSignModal from "./DocuSignModal";
import base_url from "../../api/bootapi";
import axios from "axios";
import "./PowerContent.css";
import { useSelector } from "react-redux";
import moment from "moment";

const PowerContent = React.forwardRef((props, ref) => {
  const { setbackdropopen, onRequestClose, agreementDetails, activeTab } =
    props;
  console.log(agreementDetails)
  const {
    date,
    clientName,
    clientAddress,
    passportNumber,
    clientEmail,
    bookingNumber,
    clientBirthDate,
    familyMembers,
    flightDetails,
  } = agreementDetails;

  const contentRef = useRef();

  const formatDOB = (dateOfBirth) => {
    // Try multiple possible input formats
    const formats = [
      "DD-MM-YYYY",
      "MM-DD-YYYY",
      "YYYY-MM-DD",
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      "YYYY/MM/DD",
      "DD.MM.YYYY",
      "MM.DD.YYYY",
    ];

    const parsed = moment(dateOfBirth, formats, true);

    if (!parsed.isValid()) {
      console.warn("Invalid date:", dateOfBirth);
      return "";
    }

    return parsed.format("MM-DD-YYYY");
  };
  function formatAirlineDetails() {
    if (!flightDetails || flightDetails.length === 0) {
      return "No airlines available";
    }

    return flightDetails
      .map((flight, index) => {
        const { airline, flight_number } = flight;
        return `${airline || "N/A"} (Flight Number: ${flight_number || "N/A"})`;
      })
      .join(", ");
  }

  function formatFlightDetails() {
    if (!flightDetails || flightDetails.length === 0) {
      return "No flights available";
    }
    console.log(flightDetails)
    return flightDetails
      .map((flight) => {
        const { iata_code, flight_number, date_of_travel } = flight;
        return `${iata_code || ""} ${flight_number || "N/A"} on ${formatDOB(date_of_travel) || "N/A"}`;
      })
      .join(", ");
  }

  const type_of_claim = localStorage.getItem('claimType')
  console.log(type_of_claim)


  function getClaimType(type) {
    switch (type) {
      case "overbooking":
        return "Denied boarding";

      case "denied_boarding":
        return "Denied boarding";

      case "lost_baggage":
        return "Lost luggage";

      case "damage_baggage":
        return "Damaged luggage";

      case "travel_expenses":
        return "Travel expenses";

      case "delayed_baggage":
        return "Delayed luggage";

      case "delayed":
        return "Delayed";

      case "cancelled":
        return "Cancelled";

      case "lost/damaged":
        return "Lost/Damaged";

      case "lost_wages":
        return "Lost Wages";

      case "other":
        return "Others";

      case "others":
        return "Others";




      default:
        return type;
    }
  }


  const renderClaimText = (flight) => {
    // if (activeTab === "general claims") {
    //   return (
    //     <>
    //       The Client, on its own behalf [and on behalf of the persons it is
    //       representing], declares that it has claims against {flight.airline}{" "}
    //       for compensation for:related to flight {flight.flight_number} on{" "}
    //       {formatDOB(flight.date_of_travel)}, increased by potential claims for damages
    //       suffered and interest for late payment.
    //     </>
    //   );
    // } else {
    return (
      <>
        The Client, on its own behalf [and on behalf of the persons it is
        representing], declares that it has claims against {flight.airline}{" "}
        for compensation for:

        <ol >
          <li>
            {getClaimType(type_of_claim)} flight ({flight.flight_number} and {formatDOB(flight.date_of_travel)})
          </li>
        </ol>

        increased by potential claims for damages suffered and interest for late payment (the <strong>“Claims”</strong>).

      </>
    );
  }
  const FlightDetailsList = () => {
    if (flightDetails.length > 1) {
      return (
        <div style={{ paddingLeft: "20px" }}>

          <ul style={{ listStyleType: "lower-roman", paddingLeft: "20px" }}>
            {flightDetails.map((flight, index) => (
              <>
                <li key={index}>{renderClaimText(flight)}</li>
                {index < flightDetails.length - 1 && <br />}
              </>
            ))}
          </ul>

        </div>
      );
    } else if (flightDetails.length === 1) {
      const flight = flightDetails[0];
      return <p>1.{renderClaimText(flight)}</p>;
    } else {
      return <p>No flight details available.</p>;
    }
  };

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        width: "793px",
        minHeight: "1122px",
        margin: "0 auto",
        padding: "16px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxSizing: "border-box",
        display: "none",
      }}
      ref={ref}
      className={`print-container`}
    >
      <h1 style={{ textAlign: "center", marginBottom: "16px" }}>
        POWER OF ATTORNEY
      </h1>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

        <p style={{ textAlign: "left", marginBottom: "16px" }}>Date: {formatDOB(date)}</p>
        <p style={{ textAlign: "left", marginBottom: "16px" }}>Claim ID: {bookingNumber}</p>
      </div>

      <p>I/We, the undersigned,</p>

      <ol className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        {familyMembers.map((member, index) => (
          <li key={index}>
            {member.first_name} {member.last_name}, born {formatDOB(member.date_of_birth)},
            passport number {member.passport_number}, ticket number{" "}
            {member.ticket_number}
          </li>
        ))}
      </ol>

      <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        <strong>Hereby authorize:</strong>
      </p>

      <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        {clientName}, born {formatDOB(clientBirthDate)}, passport number {passportNumber} (
        <strong>“Representative”</strong>)
      </p>

      <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        <FlightDetailsList />
      </p>

      {/* <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        Flight number: {formatFlightDetails()}
      </p> */}

      <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        The power of attorney covers all Claims (existing and potential) that I may have against
        the airline related to the above flight. The Representative may conduct all legal and
        factual actions on my behalf (including to assign my claims to Fly And Claim Inc, 11 Main
        Street, Monsey NY 10952, USA), supply necessary documents, and receive
        correspondence. The Representative may also receive compensation on my behalf.
      </p>

      <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        The power of attorney should be interpreted broadly so as to cover all actions necessary
        to achieve its aim. The Representative may grant further powers of attorney.
      </p>
      <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        The Representative may pursue the claims on any legal basis and in any
        jurisdiction/country that may be applicable.
      </p>

      <p className={`${familyMembers.length > 2 ? "avoid-break" : ""}`}>
        The power of attorney is subject to Polish law.
      </p>

      <hr style={{ margin: "20px 0" }} />

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        {familyMembers.map((member, index) => (
          <div
            key={index}
            style={{
              flex: "1 1 45%",
              textAlign: "center",
              marginTop: "20px",
            }}
            className="avoid-break"
          >
            <div
              style={{
                width: "300px",
                height: "60px",
                margin: "0 auto",
                marginBottom: "10px",
              }}
            ></div>
            <p>_____________________________________</p>
            <p className="name-text" style={{ textTransform: "uppercase" }}>
              {member.first_name} {member.last_name}
            </p>
          </div>
        ))}
      </div>

      <hr style={{ margin: "20px 0" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
        className={familyMembers.length > 3 ? "page-break" : ""}
      >
        <div style={{ flex: "1" }}>
          <p>Foglar Law Firm (NIP: 7343586718)</p>
        </div>
        <div style={{ flex: "1", textAlign: "center" }}>
          <p>www.foglar.pl</p>
        </div>
        <div style={{ flex: "1", textAlign: "right" }}>
          <p>claims@foglar.pl</p>
        </div>
      </div>

      <p>
        Note: Please email the signed document to <a href="mailto:claims@flyandclaim.com">claims@flyandclaim.com</a>
      </p>
    </div>
  );
});

export default PowerContent;
